function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import * as yup from 'yup';
import validator from "../validator";
/**
 * Nested object extension validator
 *
 * @see @/services/mapping/validator
 */

export default {
  supports: ['one', 'many', 'object'],
  build: function build(_ref, rule) {
    var type = _ref.type,
        properties = _ref.properties,
        cascade = _ref.cascade;
    var isCollection = type === 'many';

    if (!cascade) {
      return null;
    }

    if (!isCollection) {
      return validator.build(properties);
    }

    rule = rule || yup.array();

    if (_typeof(properties) === 'object' && Object.keys(properties).length > 0) {
      rule = rule.of(validator.build(properties));
    }

    return rule;
  }
};